import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseButtonSizeEnum } from '../../../shared/components/base-button/base-button-size.enum';
import { BankAccount } from '../../models/bank-account';
import { TertiaryButtonComponent } from '../../../shared/components/tertiary-button/tertiary-button.component';
import { ReviewEntryComponent } from '../../../shared/components/review-components/review-entry/review-entry.component';
import { StatusPillComponent } from '../../../shared/components/status-pill/status-pill.component';
import { IN_USE_STATUS_PILL } from '../../../../features/payment-methods/utils/payment-method-status-pill-utils';

@Component({
  selector: 'app-bank-account',
  templateUrl: './bank-account.component.html',
  styleUrls: ['./bank-account.component.scss'],
  standalone: true,
  imports: [CommonModule, TertiaryButtonComponent, ReviewEntryComponent, StatusPillComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BankAccountComponent {
  @Input() bankAccount!: BankAccount;
  @Input() readOnly = false;
  @Output() removeAccountClicked = new EventEmitter<void>();
  @Output() reviewUsageClicked = new EventEmitter<void>();

  protected readonly BaseButtonSizeEnum = BaseButtonSizeEnum;
  protected readonly inUseStatusPill = IN_USE_STATUS_PILL;
}
